import { render, staticRenderFns } from "./Datas.vue?vue&type=template&id=6fdfcc66&"
import script from "./Datas.vue?vue&type=script&lang=js&"
export * from "./Datas.vue?vue&type=script&lang=js&"
import style0 from "./Datas.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Datas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports